import React from 'react';
import {Field, reduxForm, focus} from 'redux-form';
import {registerUser} from '../actions/users';
import {login} from '../actions/auth';
import Input from './input';
import {required, nonEmpty, matches, length, isTrimmed} from '../validators';
import RaisedButton from 'material-ui/RaisedButton';
const passwordLength = length({min: 6, max: 72});
const matchesPassword = matches('password');


const style = {
    margin: 12,
  };

export class RegistrationForm extends React.Component {
    onSubmit(values) {
        const {username, password, fullname} = values;
        const user = {username, password, fullname};
        return this.props
            .dispatch(registerUser(user))
            .then(() => this.props.dispatch(login(username, password)));
    }

    render() {
        return (
            <form
                className="login-form"
                onSubmit={this.props.handleSubmit(values =>
                    this.onSubmit(values)
                )}>
                <label className="label" htmlFor="fullname">Full name</label>
                <Field component={Input} type="text" id="fullname" name="fullname" />
                <label className="label" htmlFor="username">Username</label>
                <Field
                    component={Input}
                    type="text"
                    name="username"
                    id="username"
                    validate={[required, nonEmpty, isTrimmed]}
                />
                <label className="label" htmlFor="password">Password</label>
                <Field
                    component={Input}
                    type="password"
                    name="password"
                    id="password"
                    validate={[required, passwordLength, isTrimmed]}
                />
                <label className="label" htmlFor="passwordConfirm">Confirm password</label>
                <Field
                    component={Input}
                    type="password"
                    id="password"
                    name="passwordConfirm"
                    validate={[required, nonEmpty, matchesPassword]}
                />
                <RaisedButton
                    label="Register" 
                    primary={true} 
                    style={style} 
                    type="submit"
                    disabled={this.props.pristine || this.props.submitting}
                />
            </form>
        );
    }
}

export default reduxForm({
    form: 'registration',
    onSubmitFail: (errors, dispatch) =>
        dispatch(focus('registration', Object.keys(errors)[0]))
})(RegistrationForm);



// WEBPACK FOOTER //
// ./src/components/registration-form.js